import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApplicationService, ToastService } from '../services';
import { delayedRetry } from '../../ngxs/utils';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService, private _applicationService: ApplicationService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      delayedRetry(2000),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        const defaultMessage = 'Something went wrong';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = error.error.message;
        } else {
          // server-side error
          errorMessage = error.error.error || error.error.errors;
        }
        errorMessage = errorMessage || defaultMessage;
        this.toastService.showErrorToast(errorMessage);
        this._applicationService.shownAppSpinner$.next(false);
        return throwError(error.error);
      }),
    );
  }
}
